import prepareThemeColors from '@uikit/ui-kit/colors/js/utils/theme';
import { UIKIT_SCHEME_MAP, UIKIT_SCHEME_IMPORT_MAP } from '@/common/constants/themes.constants';

export const normalizeSchemeName = (schemeName?: string): string => {
  const name = (schemeName || '').replace(/_/g, '-');

  return UIKIT_SCHEME_IMPORT_MAP[name] ? name : UIKIT_SCHEME_MAP.DEFAULT;
};

export const loadUikitColorScheme = async (schemeName) => {
  const name = normalizeSchemeName(schemeName);
  const uikitScheme = await UIKIT_SCHEME_IMPORT_MAP[name]();

  return prepareThemeColors(name, uikitScheme.default);
};

export default loadUikitColorScheme;
